<div class="flex justify-content-between pt-4 pb-3">
  <div class="flex">
    <span class="p-float-label">
      <input
        [(ngModel)]="assetMeasurementFilters.name.value"
        (keyup.enter)="beforeApplyFilters(); measurementsTable._filter();"
        pInputText
        type="text"
        id="name"
      >
      <label for="name">{{'attribute.name' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2">
      <input
        [(ngModel)]="assetMeasurementFilters['measurementType.unit'].value"
        (keyup.enter)="beforeApplyFilters(); measurementsTable._filter();"
        pInputText
        type="text"
        id="unit"
      >
      <label for="unit">{{'attribute.unit' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2 w-16rem">
      <p-multiSelect
        *ngIf="measurementTypes"
        [(ngModel)]="selectedMeasurementTypeSensors"
        [options]="measurementTypes"
        [filter]="true"
        styleClass="w-full"
        optionLabel="value"
        optionValue="value"
        inputId="measurementType"
        display="chip"
        appendTo="body"
      ></p-multiSelect>
      <label>{{'model.measurementType' | transloco}}</label>
    </span>
  </div>
  <div>
    <button
      [label]="'common.search' | transloco"
      (click)="beforeApplyFilters(); measurementsTable._filter()"
      pButton
      icon="pi pi-search"
      iconPos="right"
    ></button>
  </div>
</div>

<p-table
  [hidden]="measurements === undefined || measurements?.length === 0"
  [(first)]="first"
  [(rows)]="rows"
  [(selection)]="assetMeasurementSelection"
  [value]="measurements"
  [scrollable]="true"
  [globalFilterFields]="['name', 'measurementType.unit', 'measurementType.sensor']"
  [filters]="assetMeasurementFilters"
  [paginator]="true"
  (selectionChange)="assetMeasurementSelectionChange.emit(assetMeasurementSelection)"
  sortField="asset.alias"
  sortMode="single"
  responsiveLayout="scroll"
  dataKey="uuid"
  #measurementsTable
>
  <ng-template pTemplate="header">
    <tr>
      <th style="max-width: 3rem;">
        <p-tableHeaderCheckbox *ngIf="selectionMode === 'multiple'"></p-tableHeaderCheckbox>
      </th>
      <th pSortableColumn="asset.alias">
        {{'attribute.alias' | transloco}}
        <p-sortIcon field="asset.alias"></p-sortIcon>
      </th>
      <th pSortableColumn="name">
        {{'attribute.name' | transloco}}
        <p-sortIcon field="name"></p-sortIcon>
      </th>
      <th pSortableColumn="description">
        {{'attribute.description' | transloco}}
        <p-sortIcon field="description"></p-sortIcon>
      </th>
      <th pSortableColumn="measurementType.sensor">
        {{'model.measurementType' | transloco}}
        <p-sortIcon field="measurementType.sensor"></p-sortIcon>
      </th>
      <th pSortableColumn="dateLastValueReported">
        {{'attribute.dateLastValueReported' | transloco}}
        <p-sortIcon field="dateLastValueReported"></p-sortIcon>
      </th>
      <th pSortableColumn="lastValueReported">
        {{'attribute.lastValueReported' | transloco}}
        <p-sortIcon field="lastValueReported"></p-sortIcon>
      </th>
      <th pSortableColumn="measurementType.unit">
        {{'attribute.unit' | transloco}}
        <p-sortIcon field="measurementType.unit"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-measurement>
    <tr>
      <td class="py-0" style="max-width: 3rem;">
        <span class="p-column-title bold">{{'common.select' | transloco}}</span>
        <p-tableRadioButton *ngIf="selectionMode === 'single'" [value]="measurement"></p-tableRadioButton>
        <p-tableCheckbox *ngIf="selectionMode === 'multiple'" [value]="measurement"></p-tableCheckbox>
      </td>
      <td class="h-3rem py-0">
        <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.asset?.alias}}</p>
      </td>
      <td class="h-3rem py-0">
        <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.name}}</p>
      </td>
      <td>
        <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.description}}</p>
      </td>
      <td>
        <span class="p-column-title bold">{{'model.measurementType' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.measurementType?.sensor ?? ''}}</p>
      </td>
      <td class="h-3rem py-0">
        <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.dateLastValueReported | customDate}}</p>
      </td>
      <td>
        <span class="p-column-title bold">{{'attribute.lastValueReported' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.lastValueReported}}</p>
      </td>
      <td>
        <span class="p-column-title bold">{{'attribute.unit' | transloco}}</span>
        <p class="text-right md:text-left">{{measurement.measurementType?.unit ?? ''}}</p>
      </td>
    </tr>
  </ng-template>
</p-table>
<div *ngIf="measurements?.length === 0" class="my-7 text-center">
  <p class="text-2xl">{{'misc.noSensorsInSelectedAssets' | transloco}}</p>
</div>
<div *ngIf="measurements === undefined">
  <div *ngFor="let n of [].constructor(11)" style="margin-top: 2.2rem; margin-bottom: 2.2rem;">
    <p-skeleton></p-skeleton>
  </div>
</div>
